export type SessionWarningReason = 'inactivity' | 'token-expiry';

export interface SessionTimeoutState {
  /** El aviso de sesión por expirar está visible. */
  readonly warningVisible: boolean;
  /** Segundos restantes del periodo de gracia (cuenta regresiva). */
  readonly countdownSeconds: number;
  /** Segundos totales de gracia al iniciar el aviso. */
  readonly totalCountdownSeconds: number;
  /** Mensaje mostrado al usuario dentro del aviso. */
  readonly message: string;
  /** Motivo del aviso: inactividad o expiración real del token. */
  readonly reason: SessionWarningReason;
}

export const INITIAL_SESSION_TIMEOUT_STATE: SessionTimeoutState = {
  warningVisible: false,
  countdownSeconds: 0,
  totalCountdownSeconds: 0,
  message: '',
  reason: 'inactivity',
};
